export * from './mbr-registration-page.component';
